"use client";

import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import type { PageMedia } from "../../types";
import { isSafeFormFunnelContentHref } from "@portal/app/_common/lib/formFunnelContent";

/** Content images keep authored dimensions; galleries fill their grid cell. */
export function PageSupportingImage({
  image,
  gallery = false,
  href,
  inert = true,
  maxHeight,
}: {
  image: PageMedia;
  gallery?: boolean;
  href?: string;
  inert?: boolean;
  maxHeight?: number;
}) {
  const content = (
    <img
      src={image.url}
      alt={image.alt}
      width={image.width}
      height={image.height}
      style={{
        display: "block",
        maxWidth: "100%",
        width: gallery ? "100%" : undefined,
        height: "auto",
        maxHeight: maxHeight ?? (gallery ? 180 : undefined),
        objectFit: "contain",
      }}
    />
  );
  return (
    <Box sx={{ display: "flex", justifyContent: "center", width: "100%", minWidth: 0 }}>
      {href && isSafeFormFunnelContentHref(href) ? (
        <Link
          component={inert ? "span" : "a"}
          href={inert ? undefined : href}
          aria-disabled={inert || undefined}
          sx={{ display: "block", width: gallery ? "100%" : undefined, maxWidth: "100%" }}
        >
          {content}
        </Link>
      ) : (
        content
      )}
    </Box>
  );
}
